const legacyGroupRouteToken = (groupName) => groupName.replace(/\s/g, '_');

export const groupPatientsPath = (group) => `/groups/by-id/${encodeURIComponent(group.id)}/patients`;

export const groupPatientPath = (group, patientId) => `${groupPatientsPath(group)}/${encodeURIComponent(patientId)}`;

export const legacyGroupPatientsPath = (groupName) => `/groups/${legacyGroupRouteToken(groupName)}/patients`;

export const legacyGroupPatientPath = (groupName, patientId) => `${legacyGroupPatientsPath(groupName)}/${encodeURIComponent(patientId)}`;

export const resolveGroupRoute = (groups, {groupId, groupToken} = {}) => {
  if(!Array.isArray(groups)){
    return null;
  }

  if(groupId !== undefined && groupId !== null){
    return groups.find((group) => group && String(group.id) === String(groupId)) || null;
  }

  if(!groupToken){
    return null;
  }

  let decodedToken = groupToken;

  try{
    decodedToken = decodeURIComponent(groupToken);
  }
  catch(error){
    return null;
  }
  const exactMatch = groups.find((group) => group && group.name === decodedToken);

  if(exactMatch){
    return exactMatch;
  }

  return groups.find((group) => group && legacyGroupRouteToken(group.name) === decodedToken) || null;
};
